<template>
    <section class="lg:pt-4">
        <div class="relative mx-auto mt-4 overflow-hidden px-6 text-center">
            <ScoreSummaryGrid />
            <div class="mt-12 lg:mt-24">
                <h2
                    class="font-aktivCondensed text-2xl font-extrabold text-white md:px-0 lg:text-3xl xl:text-4xl"
                >
                    You Scored {{ resolvedHeadline }}!
                </h2>
            </div>
            <p
                v-if="slide?.body"
                class="mt-4 space-y-2 text-pretty text-white md:text-lg xl:text-xl"
                v-html="slide.body"
            ></p>

            <ResourcesBlock :block="resourcesBlock" />
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useQuizStore } from "../stores/quizStore";
import { useFormieStore } from "../stores/formieStore";
import { useAnalyticsStore } from "../stores/analyticsStore";
import type { ScoreSlide } from "../types";
import ScoreSummaryGrid from "../components/ScoreSummaryGrid.vue";
import ResourcesBlock from "../components/ResourcesBlock.vue";

const quiz = useQuizStore();
const formie = useFormieStore();
const analytics = useAnalyticsStore();

const slide = computed<ScoreSlide | undefined>(
    () =>
        quiz.slides.find((s) => s.kind === "scoreSlide") as
            | ScoreSlide
            | undefined,
);

const resourcesBlock = computed(() => slide.value?.resourcesBlock);

const questions = computed(() => quiz.questions);

function isCorrect(questionId: string): boolean {
    return quiz.getAnswer(questionId)?.isCorrect === true;
}

const resolvedHeadline = computed(() => {
    const base = slide.value?.headline || "{score} / {total}";
    return base
        .replace("{score}", String(quiz.score))
        .replace("{total}", String(quiz.totalQuestions));
});

onMounted(async () => {
    analytics.fireOnce("quiz_complete", {
        score: quiz.score,
        totalQuestions: quiz.totalQuestions,
    });

    await formie.createOrUpdateSubmission({
        currentQuestion: "score",
        score: quiz.score,
        totalQuestions: quiz.totalQuestions,
        answersJson: JSON.stringify(quiz.answers),
        completed: true,
    });
});

function openShare() {
    quiz.openShare();
}
</script>
